import { Button, Center, Stack } from '@mantine/core'
import { ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'
import { AuthLayout } from '@/components/layout/AuthLayout/AuthLayout'
import { PlatformAlert } from '@/components/ui-shared/PlatformAlert/PlatformAlert'
import { useLogout } from '@/session/useLogout'

type WorkspaceAlertWithLogoutProps = {
  message: ReactNode
  extraContent?: ReactNode
  redirectToAfterLogin?: string
}

export const WorkspaceAlertWithLogout = ({
  message,
  extraContent,
  redirectToAfterLogin
}: WorkspaceAlertWithLogoutProps) => {
  const { logout } = useLogout(redirectToAfterLogin)

  return (
    <AuthLayout variant="large">
      <Stack gap="xl">
        <PlatformAlert variant="warning" compact>
          {message}
        </PlatformAlert>

        {extraContent}

        <Center>
          <Button miw={100} size="xs" onClick={() => void logout()}>
            <FormattedMessage id="logout" />
          </Button>
        </Center>
      </Stack>
    </AuthLayout>
  )
}
